import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Toyotaetiononrentinmumbai() {



  const cardData = {
    keyword: " Toyota Etios on Rent in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable Toyota Etios on rent in Mumbai, providing a comfortable, economical, and safe travel solution for city rides, airport transfers, corporate travel, and outstation journeys. The Toyota Etios is a spacious and fuel-efficient sedan known for its smooth ride quality, wide seating comfort, and stable performance on long highway routes, making it ideal for both business and family travel. Our well-maintained Etios vehicles come with professional drivers to ensure a hassle-free and punctual travel experience across Mumbai and nearby destinations. Toyota Etios cab rental pricing in Mumbai typically starts from around ₹12 to ₹14 per km for outstation travel and flexible hourly packages for local usage depending on distance and duration. We offer one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With 24/7 availability and easy booking, Royal Route Cab is your trusted choice for Toyota Etios on rent in Mumbai.",

"topPlaces": [
  {
    "title": "Toyota Etios on Rent in Mumbai",
    "description": "Toyota Etios on rent in Mumbai is a reliable and budget-friendly cab option for daily travel, airport transfers, and short trips. It is known for its comfort, fuel efficiency, and smooth ride experience, making it ideal for solo travelers and small families."
  },
  {
    "title": "Toyota Etios Airport Cab Mumbai",
    "description": "Toyota Etios airport cab service in Mumbai is widely used for pickup and drop services. It offers a comfortable ride with sufficient luggage space, ensuring hassle-free travel for domestic and international passengers."
  },
  {
    "title": "Affordable Toyota Etios Rental Mumbai",
    "description": "Affordable Toyota Etios rental in Mumbai is a popular choice for customers looking for economical travel without compromising on comfort. It is suitable for office commutes, city rides, and personal trips."
  },
  {
    "title": "Toyota Etios for Local Travel Mumbai",
    "description": "Toyota Etios is commonly used for local travel in Mumbai due to its smooth handling and comfort. It is ideal for meetings, shopping trips, and daily commuting within the city."
  },
  {
    "title": "Toyota Etios with Driver Mumbai",
    "description": "Toyota Etios with driver service in Mumbai offers a stress-free travel experience with professional chauffeurs. It is perfect for those who prefer convenient and safe transportation across the city."
  },
  {
    "title": "Toyota Etios for Outstation Trips Mumbai",
    "description": "Toyota Etios is a good option for outstation trips from Mumbai to nearby destinations. It provides comfortable seating, good mileage, and a smooth driving experience for long journeys."
  },
  {
    "title": "Corporate Toyota Etios Cab Mumbai",
    "description": "Corporate Toyota Etios cab service in Mumbai is preferred by business travelers for meetings, airport transfers, and daily office commutes. It ensures punctual and reliable transportation."
  },
  {
    "title": "Toyota Etios Chauffeur Service Mumbai",
    "description": "Chauffeur-driven Toyota Etios service in Mumbai provides comfortable and professional travel for both personal and business needs, ensuring a smooth and safe journey."
  },
  {
    "title": "Economy Cab Toyota Etios Mumbai",
    "description": "Economy Toyota Etios cab service in Mumbai is ideal for budget-conscious travelers looking for reliable and comfortable transportation for everyday use."
  },
  {
    "title": "Toyota Etios One Way Cab Mumbai",
    "description": "Toyota Etios one-way cab service in Mumbai is perfect for point-to-point travel needs, offering affordable and convenient rides for short and medium-distance journeys."
  }
],






services: [
  {
    name: "Toyota Etios on Rent Mumbai",
    description: "Toyota Etios on rent Mumbai offers a reliable and budget-friendly sedan option for city and outstation travel. Known for its comfort and durability, this car is ideal for individuals, families, and business travelers. Clean vehicles and professional drivers ensure a smooth ride. It guarantees a comfortable and economical journey."
  },
  {
    name: "Etios Cab Service Mumbai",
    description: "Etios cab service Mumbai provides dependable transportation with well-maintained sedan vehicles. This service is ideal for local travel, airport transfers, and outstation trips. Professional drivers ensure safe and timely service. It ensures a smooth and hassle-free journey."
  },
  {
    name: "Etios Taxi Mumbai",
    description: "Etios taxi Mumbai offers comfortable and affordable travel for daily commuting and long-distance trips. This sedan is widely preferred for its smooth ride and good mileage. Ideal for city rides and airport transfers. It ensures a reliable travel experience."
  },
  {
    name: "Etios Rental Mumbai",
    description: "Etios rental Mumbai provides flexible car rental solutions for personal and corporate use. Customers can hire the vehicle for hourly, daily, or outstation travel. Easy booking and transparent pricing enhance convenience. It ensures a pleasant journey."
  },
  {
    name: "Etios Car Hire Mumbai",
    description: "Etios car hire Mumbai allows customers to rent a sedan for flexible travel needs. This service is ideal for business trips, family outings, and personal travel. Well-maintained vehicles ensure reliability. It guarantees a comfortable experience."
  },
  {
    name: "Etios Cab Booking Mumbai",
    description: "Etios cab booking Mumbai allows travelers to reserve their ride easily with flexible options. Customers can select pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Etios Taxi Booking Online Mumbai",
    description: "Etios taxi booking online Mumbai provides a quick and convenient way to book sedan cabs. Customers can compare pricing and options easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Etios Rental Price Mumbai",
    description: "Etios rental price Mumbai varies based on distance, trip type, and duration. Transparent pricing ensures no hidden charges. Budget-friendly rates make it ideal for everyday travel. It helps travelers plan efficiently. It ensures value for money."
  },
  {
    name: "Etios Taxi Fare Mumbai",
    description: "Etios taxi fare Mumbai is designed to be affordable for city and outstation travel. Fare depends on route, usage, and duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Etios One Way Cab Mumbai",
    description: "Etios one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and intercity travel. It ensures smooth and economical journeys."
  },
  {
    name: "Etios Round Trip Cab Mumbai",
    description: "Etios round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and business travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Etios Rental Mumbai",
    description: "Cheap Etios rental Mumbai offers budget-friendly options for sedan travel without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Etios Cab Service Mumbai",
    description: "Best Etios cab service Mumbai ensures top-quality vehicles and professional drivers for a smooth travel experience. This service focuses on punctuality, comfort, and customer satisfaction. It guarantees a reliable journey."
  },
  {
    name: "Etios Airport Cab Mumbai",
    description: "Etios airport cab Mumbai provides convenient pickup and drop services to Mumbai airport. This service ensures timely travel and comfortable rides. Ideal for business travelers and tourists. It guarantees a stress-free airport transfer."
  },
  {
    name: "Etios Outstation Cab Mumbai",
    description: "Etios outstation cab Mumbai offers reliable long-distance travel with comfortable seating and good mileage. This service is ideal for family trips and business travel. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  }
],

tableData: [
  ["Toyota Etios on Rent Mumbai", "Etios Cab Service Mumbai"],
  ["Etios Taxi Mumbai", "Etios Rental Mumbai"],
  ["Etios Car Hire Mumbai", "Etios Cab Booking Mumbai"],
  ["Etios Taxi Booking Online Mumbai", "Etios Rental Price Mumbai"],
  ["Etios Taxi Fare Mumbai", "Etios One Way Cab Mumbai"],
  ["Etios Round Trip Cab Mumbai", "Cheap Etios Rental Mumbai"],
  ["Best Etios Cab Service Mumbai", "Etios Airport Cab Mumbai"],
  ["Etios Outstation Cab Mumbai", "Toyota Etios on Rent Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Toyota Etios on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly Toyota Etios rental in Mumbai, perfect for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Comfortable & Reliable Sedan",
    WhyChoosedescription: "Toyota Etios is known for its smooth ride, comfort, and reliability, making it ideal for city and long-distance travel."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Mumbai routes, ensuring safe and hassle-free travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Etios rental including all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Toyota Etios rental service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Etios cars are regularly serviced, sanitized, and maintained for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book Toyota Etios for local Mumbai travel, airport pickup-drop, or outstation trips with customized packages."
  },
  {
    WhyChooseheading: "Trusted Sedan Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Toyota Etios rental in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Toyota Etios on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Toyota Etios rental services in Mumbai for local and outstation travel." },
  { question: "Is Toyota Etios suitable for outstation trips?", answer: "Yes, Toyota Etios is ideal for both city and long-distance travel due to its comfort and reliability." },
  { question: "Is Etios rental available 24 hours?", answer: "Yes, our Toyota Etios rental service operates 24/7." },
  { question: "Do you provide driver with Etios rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide airport pickup with Etios?", answer: "Yes, we offer Mumbai airport pickup and drop services with Toyota Etios." },
  { question: "Can I book Etios for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "Toyota Etios on rent in Mumbai with Royal Route Cabs was very comfortable and budget-friendly. The car was clean and perfect for city and highway travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Good experience with Toyota Etios rental in Mumbai. The ride was smooth, the vehicle was well-maintained, and the service felt reliable throughout the journey.",
    rating: 5
  }
];













  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Toyota Etios on Rent in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/toyota-etios-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Toyota Etios on rent in Mumbai with Royal Route Cabs for comfortable, budget-friendly, and reliable travel. Ideal for airport transfers, local rides, and outstation trips with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/toyota-etios-on-rent-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Toyota Etios on Rent in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Toyota Etios on rent in Mumbai with Royal Route Cabs. Affordable sedan taxi for airport, local, and outstation travel. Safe, reliable & 24x7 available service."
  />

  <meta
    name="keywords"
    content="toyota etios on rent mumbai, etios cab service mumbai, etios taxi mumbai, etios rental mumbai, etios car hire mumbai, etios cab booking mumbai, etios taxi booking online mumbai, etios rental price mumbai, etios taxi fare mumbai, etios one way cab mumbai, etios round trip cab mumbai, cheap etios rental mumbai, best etios cab service mumbai, etios airport cab mumbai, etios outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Toyotaetiononrentinmumbai;